<!-- 商家端 - 直播带货订单（复用订单列表，默认仅直播单） -->
<template>
  <OrderList force-live-only />
</template>

<script setup lang="ts">
import OrderList from '@/views/merchant/order/OrderList.vue'

defineOptions({ name: 'MerchantLiveOrders' })
</script>
